import { Injectable } from '@angular/core';
import {RuleDTO, RulesDependFieldsDTO} from '@signature-it/ngx-generic/models';
import { Gender } from '@signature-it/ngx-generic/enums';
import { IRulesDependFields } from '@signature-it/ngx-generic/interfaces';

declare let _: any;

@Injectable({
	providedIn: 'root'
})
export class RulesService {

	testValidation(ans: any, product: any, rule: RuleDTO, data = {}) {
		let urlParams = new URLSearchParams(location.search);
		const debug = urlParams.get('debug') ? `console.log(product); debugger;// ruleId: ${rule.ruleId}\n`: '';
		let calc = rule.evalCalcFields(ans, product, data);
		try{
			const func =  new Function('ans', 'product', 'calc', `${debug} return ${rule.ruleJS};`);
			return func(ans, product, calc);
		} catch (err) {
			console.log(`${err.message} --- RULE: ${JSON.stringify(rule)} PRODUCT: ${JSON.stringify(product)}`);
			return false;
		}
	}

	renderValidatorMsg(ans: any, product: any, rule: RuleDTO, data = {}) {
		let calc = rule.evalCalcFields(ans, product, data);
		let errors = {};
		[Gender.MALE, Gender.FEMALE].forEach(gender => {
			let msg = gender == Gender.FEMALE ? rule.validatorMsgFm: rule.validatorMsg;
			msg = msg.replace(/\<\%product.(.*?)\%\>/g, (function ($1, $2) { return product[$2 + '_s'] ? product[$2 + '_s'].replace(/\|/g, ', '): $1; }));
			errors[gender] = msg.replace(/\<\%calc.(.*?)\%\>/g, (function ($1, $2) { return calc[$2] ? calc[$2]: $1; }));
		});
		return errors;
	}

	getAllHiddenFields(ans: any, product: any, rulesDependFields: RulesDependFieldsDTO) {
		let hiddenFields = [];
		Object.keys(rulesDependFields).forEach(field => {
			if(!this.testValidation(ans, product, rulesDependFields[field])) {
				hiddenFields.push(field)
			}
		});
		return hiddenFields;
	}

}
